<template>
  <div class="body">
    <div class="popup">
      <div class="t-c">
        <img src="@/assets/dzp/t_h.png" alt="" />
      </div>
      <van-field v-model="iccid" name="mobile" label="号码：" placeholder="请输入你要激活的号码"
        :rules="[{ required: true, message: '请输入你要激活的号码' }]" />
      <van-button class="bu_tn" round block type="info" native-type="submit" @click="onSubmit">确认</van-button>
    </div>
    <div class="kf" @click="kflink()">
      <div class="kf_img"> <img src="@/assets/kf.png" alt="" /></div>
      <div class="kf_content">在线咨询</div>
    </div>
  </div>
</template>
<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { wxRequest } from "@/api/user.js";
import SeAutocomplete from "@/components/SeAutocomplete";
import Advertisement from "@/components/Advertisement";
export default {
  data() {
    return {
      code: "",
      iccid: "",
    };
  },
  async created() {
    var source = this.getQueryVariable("source")
      ? this.getQueryVariable("source")
      : process.env.VUE_APP_APPID;
    localStorage.setItem("isHeadquarterAppid", true);
    var appid = source ? source : process.env.VUE_APP_APPID;
    //获取总部公众号appid
    await wxRequest("/sim/appId", {}, "post").then((res) => {
      if (res.data.code == 200) {

        appid = res.data.data.collectAppid;
      }
    });
    this.$store.commit("setIsHeadquarterAppid", "true");
    localStorage.setItem("isHeadquarterAppid", true);
    localStorage.setItem("appid", appid);
    console.log(appid);

    //先查询是否是乐刷支付 如果是乐刷支付 就不用授权了
    await wxRequest(
      "sim/get/pay/state",
      {
        iccid: localStorage.getItem("iccid"),
      },
      "post"
    ).then((res) => {
      localStorage.setItem("payCode", res.data.code);
      if (res.data.code == 200) {
        localStorage.setItem("leshuaPay", 1);
        this.code = "leshua";
        this.iccid = localStorage.getItem("recordLoginText");
      } else {
        var redirectUrl = window.location.href;
        var index = redirectUrl.indexOf("code");
        redirectUrl = encodeURIComponent(redirectUrl);
        localStorage.setItem("leshuaPay", 2);
        if (index < 0) {
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
        } else {
          var search = window.location.search;
          console.log("search", search);
          var startIndex = search.indexOf("code");
          var endIndex = search.indexOf("&", startIndex);
          var str = search.slice(startIndex, endIndex);
          var code = str.slice(str.indexOf("=") + 1);
          this.code = code;
          this.iccid = localStorage.getItem("recordLoginText");
        }
      }
    });
  },
  methods: {
    // 客服跳转
    kflink() {
      window.location.href = 'https://work.weixin.qq.com/kfid/kfceda7e24c02e32677'
    },
    //获取url参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    onSubmit() {
      let recordLoginText = this.iccid;
      let data = {
        requestId: this.iccid,
        code: this.code,
      };
      wxRequest("sim/bind", data, "get").then((res) => {
        if (res.data.code == 200) {
          let record = res.data.data;
          let iccid = record.iccid;
          this.$store.state.isNewPage = 0;
          localStorage.setItem("isNewPage", 0);

          localStorage.setItem("bindPhone", record.bindPhone);
          localStorage.setItem("titleUrl", record.titleUrl);
          localStorage.setItem("titleImg", record.titleImg);
          localStorage.setItem("isTitle", record.isTitle);


          localStorage.setItem("isCode", true);
          localStorage.setItem("mobile", record.mobile);
          localStorage.setItem("supplierTypeName", record.supplierTypeName);
          localStorage.setItem("wxHeadImg", record.wxHeadImg);
          localStorage.setItem("wxNickName", record.wxNickName);
          localStorage.setItem("shebeiLogin", 0);
          localStorage.setItem("recordLoginText", recordLoginText);
          localStorage.setItem("supplierName", record.supplierName);
          localStorage.setItem("intoNo", record.intoNo);
          localStorage.setItem("isSale", record.isSale);
          localStorage.setItem("yucun", record.yucun);
          localStorage.setItem("kefuUrl", record.kefuUrl);
          localStorage.setItem("priceImgUrl", record.priceImgUrl);
          localStorage.setItem("ishavePkg", record.ishavePkg);
          localStorage.setItem("isMyLogin", 0);
          localStorage.setItem("isSale", record.isSale);
          localStorage.setItem("salePrice", record.salePrice);
          localStorage.setItem("ishavePrice", record.ishavePrice);
          sessionStorage.setItem("isLine", true);
          localStorage.setItem("flowRatePool", record.flowRatePool);
          this.$store.state.flowRatePool = res.data.data.flowRatePool;
          localStorage.setItem("iccid", record.iccid);
          localStorage.setItem("openId", record.openId);
          localStorage.setItem("virtualNo", record.virtualNo);

          localStorage.setItem("userPhone", record.userPhone);
          this.$store.state.userPhone = record.userPhone;

          this.$store.state.recordLoginText = recordLoginText;
          this.$store.state.supplierCode = res.data.data.supplierCode;
          this.$store.state.iccid = iccid;
          this.$store.commit("setIccid", iccid);

          this.$store.state.intoNo = record.intoNo;
          sessionStorage.setItem("intoNo", record.intoNo);
          //未实名的电信卡用户（通过cardType字段判断），实名认证时将只需要绑定
          let cardType = record.supplierTypeCode;
          let _data = {
            requestId: iccid,
            code: this.code,
          };
          if (record.bindPhone == 2) {
            this.$router.push({
              path: "/user/bindPhoneOnely",
              query: {
                iccid: record.iccid,
              },
            });
          } else if (record.ishavePkg > 0) {
            this.$router.replace("/user/home");
          } else if ((record.isSale == 1 || record.isSale == 3) && record.ishavePrice == 0) {
            this.$router.replace("/user/simOpens");
          } else if (record.isSale > 0 && record.ishavePrice == 0) {
            this.$router.replace("/user/simOpens");
          } else {
            if ((record.bindPhone == 0) || (record.bindPhone == 1 && record.ishavePkg == 0)) {
              localStorage.setItem("phoneNo", record.userPhone);
              this.$router.replace("/user/home");
            } else {
              this.$router.push({
                path: "/user/bindPhoneOnely",
                query: {
                  iccid: record.iccid,
                },
              });
            }

          }
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.kf {
  width: 56px;
  height: 72px;
  position: fixed;
  top: 60%;
  right: 0;

  .kf_img {
    width: 48px;
    height: 48px;
    background: #38b6ff;
    text-align: center;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 6px;

    img {
      height: 28px;
      width: 28px;
      animation-name: tadaYrtcq;
      animation-timing-function: ease-in-out;
      animation-iteration-count: infinite;
      animation-duration: 3.2s
    }
  }

  .kf_content {
    font-weight: bold;
    color: #38b6ff;
    font-size: 13px;
  }
}

.body {
  background: url("../../assets/dzp/659841b5.png") no-repeat center;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  position: relative;

  .popup {
    background: linear-gradient(0deg, #ffe1b1, #fff);
    box-sizing: border-box;
    padding: 25px 0;
    width: 325px;
    position: fixed;
    left: 0;
    right: 0;
    margin: auto;
    top: 25%;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    box-shadow: 0 6px 6px 0 rgb(219 0 0 / 75%);

    .t-c {
      height: 60px;
      text-align: center;

      img {
        height: 100%;
      }
    }

    .van-cell {
      height: 50px;
      width: 275px;
      border-radius: 17px;
      border: 2px solid #000;
      padding-left: 10px;
      background: none;
      margin: auto;
      margin-top: 20px;

      ::v-deep .van-cell__title {
        width: 50px;
      }

      ::v-deep .van-cell__value {
        .van-field__body {
          .van-field__control {
            line-height: 24px;
          }
        }
      }
    }

    .bu_tn {
      height: 50px;
      line-height: 50px;
      text-align: center;
      width: 275px;
      color: #fff;
      background: black;
      border-radius: 17px;
      margin: auto;
      margin-top: 20px;
      border: 1px solid black;
    }
  }
}
</style>